<template>
  <div id="SpReschedulingList">
    <h1>あなたに届いている依頼</h1>
    <table border="1">
      <tr>
        <th>依頼主</th><th>理由</th><th>処理ページ</th>
      </tr>
      <tr v-for="(content, index) in list" :key="content.data">
        <td>{{getUsername(content.sender)}} 様</td><td v-if="content.reason">{{content.reason}}</td><td v-if="content.rescheduling_hash"><a v-bind:href="'SpRescheduling/' + content.rescheduling_hash">処理ページへ</a></td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'SpReschedulingList',
  data () {
    return {
      list: null,
      receiverInfo: {}
    }
  },
  mounted () {
    this.getReschedulingetList(this.$store.state.userInfo.user_id).then((res) => {
      this.list = res.data
    }).then(() => {
      this.getLectures({})
    })
  },
  methods: {
    ...mapActions([
      'getReschedulingetList',
      'getLectures'
    ]),
    getUsername (id) {
      let receiverId = Number(id)
      var name = ''
      for (let lecture of this.$store.state.lectureInfo) {
        if (lecture.teacher.id === receiverId) {
          name = lecture.teacher.fullname
        } else if (lecture.student.id === receiverId) {
          name = lecture.student.fullname
        }
      }
      return name
    }
  }
}
</script>

<style scoped>
#SpReschedulingList{
  width: 100%;
  text-align: center;
}
table{
  width: 80%;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// SpreschedulingList.vue?555434a8